import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.857 15.118v-1.572h.786a.785.785 0 0 0 .786-.785v-.268a2.876 2.876 0 0 0-2.876-2.875h-3.677A2.876 2.876 0 0 0 12 12.493v.268a.786.786 0 0 0 .786.785h.785v1.572H11.64l-1.344-2.004a.79.79 0 0 0-.652-.353h-.786V6.475A2.357 2.357 0 0 0 6.5 4.118h-.786v-.786a.786.786 0 0 0-.785-.786H2.964a1.964 1.964 0 0 0 0 3.929H4.93a.786.786 0 0 0 .785-.786H6.5a.786.786 0 0 1 .786.786v6.286H4.929a.785.785 0 0 0-.786.785v3.748A3.34 3.34 0 0 0 6.5 20.476a1.965 1.965 0 0 0 3.929.142h6.364a1.964 1.964 0 0 0 3.85 0h1.571a.786.786 0 0 0 .786-.786v-1.39a3.33 3.33 0 0 0-3.143-3.324M2.964 4.903a.393.393 0 1 1 0-.785h1.179v.785zm11.912 6.286h3.677a1.3 1.3 0 0 1 1.194.786h-6.066a1.3 1.3 0 0 1 1.195-.786m.267 2.357h3.143v1.572h-3.143zm-6.679 7.072a.393.393 0 1 1 0-.785.393.393 0 0 1 0 .785m10.215 0a.393.393 0 1 1 0-.786.393.393 0 0 1 0 .786m2.75-1.572h-1.187a1.948 1.948 0 0 0-3.143 0h-7.071a1.95 1.95 0 0 0-3.064-.078 1.76 1.76 0 0 1-1.25-1.674v-2.962H9.22l1.343 2.004a.79.79 0 0 0 .652.353h8.462a1.75 1.75 0 0 1 1.753 1.752z"
    }, null, -1)
  ]))]))
}
export default { render: render }